import { Navigate } from "react-router-dom";
import { Gift } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { ComplimentaryPlanCard } from "@/components/quality/ComplimentaryPlanCard";

export default function Owner() {
  const { user } = useAuth();
  if (user && !user.is_admin) return <Navigate to="/dashboard" replace />;
  return (
    <div className="p-4 md:p-6 max-w-4xl mx-auto space-y-5" data-testid="owner-tools-page">
      <div>
        <h1 className="font-display text-3xl font-extrabold flex items-center gap-2"><Gift className="w-7 h-7 text-amber-300" /> Owner tools</h1>
        <p className="text-sm text-slate-400 mt-1">Visible only to admin accounts (server-verified). Every action here is written to the admin audit log. Signed in as <span className="font-mono-ticker text-slate-200" data-testid="owner-email">{user?.email}</span>.</p>
      </div>
      <ComplimentaryPlanCard />
      <p className="text-xs text-slate-500">More admin diagnostics (build health, Stripe readiness, webhook health, research e-mail) remain at the bottom of <a href="/performance#complimentary-plan" className="text-cyan-300 hover:underline">Performance & Transparency</a>.</p>
    </div>
  );
}
